import { proposalHeaderData, proposalHeaders } from '../../constant/gms-constant';

interface Props {
    headers?: string[];
}

export default function ProposalTHead({ headers = [], }: Props) {

    // const headers = proposalHeaders.filter((header) => !excludeHeaders.includes(header));

    return (
        <thead className="sticky top-0 z-20 bg-[#eef6fc]">
            <tr className="border-b border-[#186cb2]/15">
            {/* <tr className="border-b border-[#186cb2]/15"> */}
                {headers.map((header, index) => {
                    // const widthClass = header === 'GROUP NAME' ? 'max-w-[100px]' : '' 
                    const widthClass = '' 
                    // const widthClass =
                    //     header === 'STATUS'
                    //         ? 'min-w-[130px]'
                    //         : header === 'GROUP NAME'
                    //         ? 'min-w-[220px]'
                    //         : header === 'EMAIL'
                    //         ? 'min-w-[220px]'
                    //         : header === 'PREPARED BY'
                    //         ? 'min-w-[180px]'
                    //         : header === 'PRODUCT'
                    //         ? 'min-w-[180px]'
                    //         : header === 'ACTION'
                    //         ? 'min-w-[130px] text-center'
                    //         : 'min-w-[160px]';
                    const isConflictProposalAction = header === proposalHeaderData.conflictProposalAction.label;
                    return (
                        <th
                            key={index}
                            className={`${isConflictProposalAction ? "text-center" : "text-left"} ${widthClass} px-3 py-2 text-[10px] font-semibold uppercase tracking-wide text-[#186cb2] sm:px-4 sm:text-[11px] `}
                        >
                            {header}
                        </th>
                    );
                })}
            </tr>
        </thead>
    );
}